import styled from 'styled-components';
import PermissionTable from './components/PermissionTable';
import PermissionFilter from './components/PermissionFilter';
import colorTheme from 'constants/color';
import { ConfigProvider } from 'antd';


const RolePermissionSetting = () => {

  return (
    <Container>
      <ConfigProvider
        theme={{
        components: {
          Checkbox: {
            colorPrimary: colorTheme['v2_secondary_3'],
            colorBorder: colorTheme['v2_secondary_3'],
            colorPrimaryHover: colorTheme['v2_secondary_3'],
          },
          Switch: {
            colorPrimary: '#02D256',
            colorBorder: '#02D256',
            colorPrimaryHover: '#02D256',
          }
        },
      }}>

        <PermissionFilter/>
        <PermissionTable/>
      </ConfigProvider>
    </Container>
  );
};

export default RolePermissionSetting;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 16px;
  flex: 1;
  position: relative;


  .ant-checkbox-inner {
    width: 24px;
    height: 24px;
  }

  .ant-checkbox-inner::after {
    width: 8px;
    height: 13px;
  }

  .ant-checkbox-indeterminate .ant-checkbox-inner:after {
    width: 13px;
    height: 13px;
  }
`;
